export const DECRYPT_VAULT_FORM_ID = 'decrypt-vault-form';
export const EDIT_VAULT_FORM_ID = 'edit-vault-form';
export const AUDIT_TRAILS_ID = 'audit-trails';

// A finished onboarding's results change only through this page's own mutations, and each one invalidates the whole
// cache. The gcTime outlasts a long read of one onboarding, so prefetched neighbours are still there afterwards.
export const SETTLED_ONBOARDING_CACHE = { staleTime: 5 * 60_000, gcTime: 30 * 60_000 };

// Entity-wide insights that each onboarding filters on the client, so a switch between onboardings shouldn't refetch
// them. Short, because a running onboarding keeps adding events.
export const ENTITY_INSIGHTS_STALE_TIME = 30_000;
